import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['Mariana G.', 'Roberto F.', 'Laura M.', 'Carlos D.', 'Silvia P.', 'Andrea S.', 'Fernando L.', 'Patricia B.', 'Gustavo R.', 'Natalia C.'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Santa Fe', 'Corrientes'];
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimer = setTimeout(() => {
      triggerNotification();
    }, 5000);
    const interval = setInterval(() => {
      triggerNotification();
    }, 45000 + Math.random() * 30000); // Random interval between 45s and 75s
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  const triggerNotification = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    setData({
      name: randomName,
      city: randomCity
    });
    setVisible(true);
    // Hide after 5 seconds
    setTimeout(() => {
      setVisible(false);
    }, 5000);
  };
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-in slide-in-from-bottom-5 fade-in duration-500" data-id="element-232">
      <div className="bg-white rounded-lg shadow-lg border-l-4 border-green-500 p-4 flex items-center gap-3 max-w-xs" data-id="element-233">
        <div className="bg-green-100 p-2 rounded-full" data-id="element-234">
          <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-235" />
        </div>
        <div data-id="element-236">
          <p className="text-sm font-medium text-gray-900" data-id="element-237">
            <span className="font-bold" data-id="element-238">{data.name}</span> de {data.city}
          </p>
          <p className="text-xs text-gray-600" data-id="element-239">
            compró SIC 360 hace unos instantes
          </p>
        </div>
      </div>
    </div>;
}